module.exports = __webpack_public_path__ + "img/05bcd37cb5089aba9ed677bffc989c9.e31dfb08.png";